import { ModalActivationContext } from 'contexts';
import { useContext } from 'react';
import { isMobile } from 'services/mobile';

export const DownloadAllFilesBlock = () => {
  const { toggleDownloadsModal } = useContext(ModalActivationContext);
  const mobile = isMobile();

  const onClickDownload = () => {
    toggleDownloadsModal(true, null);
  };

  return (
    mobile ?
      <div className='flex items-center' data-test='download-all-files' onClick={onClickDownload}>
        <span className='text-font-1 font-medium ms:text-font-3'>Bulk download</span>
      </div> :
      <div className='text-font-1 font-medium ms:text-font-3' data-test='download-all-files' onClick={onClickDownload}>
        Bulk download
      </div>
  );
};
